import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  StatusFormatter,
  columnsComplate,
  columnsUploadPDIIN,
  components,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  selectStyles,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
  useStylesSelect,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  addUploadFile,
  addUploadFilePDIIN,
  editInbound,
  editVehicle,
  editVehicleComplate,
  editVehicleCompleteStocktake,
  editVehicleConfirmStocktake,
  editVehicleConfrim,
  editVehicleStocktakeWorkFlow,
  fetchFileTemplate,
  fetchFileTemplateBlob,
  fetchIdInbound,
  fetchIdVehicleFind,
  fetchIdVehicleFindStocktake,
  fetchVehicleStocktake,
  removeVehicle,
  removeVehicleWorkFlow,
  removeVehicleWorkFlowStocktake,
  selectIdInbound,
  selectInspection,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
} from "../inbound/inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InputNumber from "../../utility/InputNumber";
import { env } from "../../../env";
import {
  prosesUpload,
  prosesUploadCancel,
} from "../miscellaneous/MiscellaneousSlice";
import {
  addStocktakeVehicleUnplaned,
  fetchIdStocktake,
  selectIdStocktake,
} from "./stocktakeSlice";
import { ModalLocationRadio } from "./ModalLocationRadio";
import LoadingFetchData from "../../utility/LoadingFetchData";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const WorkflowStocktakePage = ({
  active,
  paramFilter,
  setParamFilter,
  paramValue,
  setParamValue,
  value,
  setValue,
  formValues,
  setFormValues,
  show,
  setShow,
  showScan,
  setShowScan,
  create,
  setCreate,
  setGetData,
  getData,
  showUnplaned,
  setShowUnplaned,
}) => {
  const classes = useStyles();
  const classesSelect = useStylesSelect();

  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdStocktake);
  const data = useSelector(selectVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [status, setStatus] = useState("");
  const [force, setForce] = useState(false);
  const inputRef = useRef(null);

  const [tableData, setTableData] = useState([]);

  const [row, setRow] = useState(null);

  const [scanFrom, setScanFrom] = useState("");
  const [overlayLoading, setOverlayLoading] = useState(false);

  // useEffect(() => {
  //   // Reset on first load
  //   if (active === 1Zz) {
  //     setForce(true);
  //   }
  // }, [active]);

  useEffect(() => {
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
        // list: list,
        // listColumns: listDamage,
      };
    });

    setTableData(initData);
  }, [data]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setForce(false);
    }
  }, [force]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setParamFilter("");
    } else {
      setParamFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let result;
    let params = {};

    if (value === 0) {
      params.stocktake_planned = "Y,N";
    } else if (value === 1) {
      params.stocktake_planned = "C";
    } else if (value === 2) {
      params.stocktake_confirm = "Y";
    }

    params.stocktake_id = id;
    params[paramFilter] = paramValue;
    // params.vehicle_status = result;
    params.is_planned = "Y,N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleStocktake(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let result;
      let params = {};

      if (value === 0) {
        params.stocktake_planned = "Y,N";
      } else if (value === 1) {
        params.stocktake_planned = "C";
      } else if (value === 2) {
        params.stocktake_confirm = "Y";
      }

      params.stocktake_id = id;
      params[paramFilter] = paramValue;
      // params.vehicle_status = result;
      params.is_planned = "Y,N";
      params.pageNo = page;
      params.pageSize = sizePerPage;

      try {
        const response = await dispatch(fetchVehicleStocktake(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {row.stocktake_date !== null && (
            <OverlayTrigger
              overlay={
                <Tooltip id="products-edit-tooltip">
                  {value !== 2 ? "Edit" : "View"}
                </Tooltip>
              }
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={() => {
                  setFormValues({
                    ...formValues,
                    vin: {
                      value: row.vin,
                      error: false,
                      required: "Y",
                    },
                    von: {
                      value: row.von,
                      error: false,
                      required: "N",
                    },
                    remarks: {
                      value: row.remark_stocktake,
                      error: false,
                      required: "N",
                    },
                    from_location: {
                      value: row.current_location,
                      error: false,
                      required: "N",
                    },
                    location: {
                      value:
                        row.location_stocktake_id === null ||
                        row.location_stocktake_id ===
                          "00000000-0000-0000-0000-000000000000"
                          ? ""
                          : row.location_stocktake_id,
                      error: false,
                      required: "Y",
                    },
                    location_name: {
                      value: row.location_stocktake_name,
                      error: false,
                      required: "Y",
                    },
                    count_date: {
                      value: row.stocktake_date,
                      error: false,
                      required: "Y",
                    },
                    stocktake_planned: {
                      value: row.stocktake_planned,
                      error: false,
                      required: "N",
                    },
                  });
                  setRow(row);
                  setCreate(false);
                  setShow(true);
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  {value === 2 ? (
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")}
                    />
                  ) : (
                    <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                  )}
                </span>
              </div>
            </OverlayTrigger>
          )}
          {row.stocktake_date !== null && (
            <>
              {value !== 2 && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={(e) => handleDelete(e, row)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "System Location",
      dataField: "current_location",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
      hidden: value !== 2 ? false : true,
    },
    {
      text: "System Location",
      dataField: "from_location_stocktake",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
      hidden: value === 2 ? false : true,
    },
    {
      text: "Count Location",
      dataField: "location_stocktake_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },

    {
      text: "Stock-Take Date",
      dataField: "stocktake_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
      formatter: formatDate,
    },
    {
      text: "Stock-Take Remarks",
      dataField: "remark_stocktake",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "User",
      dataField: "stocktake_updatedby",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "60px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const handleClose = () => {
    setCreate(false);
    setShow(false);
    setShowUnplaned(false);
    setShowScan(false);
    setFormValues({
      vin: {
        value: "",
        error: false,
        required: "Y",
      },
      von: {
        value: "",
        error: false,
        required: "N",
      },
      remarks: {
        value: "",
        error: false,
        required: "N",
      },
      from_location: {
        value: "",
        error: false,
        required: "N",
      },
      location: {
        value: "",
        error: false,
        required: "Y",
      },
      location_name: {
        value: "",
        error: false,
        required: "Y",
      },
      count_date: {
        value: "",
        error: false,
        required: "Y",
      },
    });

    setRow(null);
  };
  const handleCloseScan = () => {
    setScanFrom("");
    setShowScan(false);
  };

  const handleSave = async (status) => {
    console.log(formValues, "formValues");
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    let params;

    if (create === true) {
      params = {
        stocktake_id: id,
        vin: formValues.vin.value,
        von: formValues.von.value,
        stocktake_date: formValues.count_date.value,
        location_stocktake_id: formValues.location.value,
        location_id: formValues.location.value,
        remarks: formValues.remarks.value,
        vehicle_status: "5421",
        stocktake_planned: formValues.stocktake_planned.value,
      };
    } else {
      params = {
        stocktake_id: id,
        vin: formValues.vin.value,
        von: formValues.von.value,
        stocktake_date: formValues.count_date.value,
        location_stocktake_id: formValues.location.value,
        location_id: formValues.location.value,
        remarks: formValues.remarks.value,
        vehicle_id: row !== null ? row.vehicle_id : "",
        vehicle_status: "5421",
        stocktake_planned: formValues.stocktake_planned.value,
      };
    }

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleStocktakeWorkFlow(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdStocktake(id));
        await handleSearch();
        await setShow(false);
        await handleClose();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleSaveConfrim = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = {
      stocktake_id: id,
      vin: formValues.vin.value,
      von: formValues.von.value,
      stocktake_date: formValues.count_date.value,
      location_stocktake_id: formValues.location.value,
      remarks: formValues.remarks.value,
      location_id: formValues.location.value,
      vehicle_status: "5421",
      stocktake_planned: formValues.stocktake_planned.value,
    };
    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleStocktakeWorkFlow(params));
      if (response.payload.status === 200) {
        const responseConfirm = await dispatch(
          editVehicleStocktakeWorkFlow({
            ...params,
            vehicle_status: "5423",
          })
        );

        if (responseConfirm.payload.status === 200) {
          const action = await showSuccessDialog(
            responseConfirm.payload.data.message
          );
          await dispatch(fetchIdStocktake(id));
          await handleClose();
          await handleSearch();
        } else {
          await handleClose();
          showErrorDialog(responseConfirm.payload.data.message);
        }
      } else {
        await handleClose();

        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      await handleClose();

      console.log(error.message);
    }
  };

  const handleSaveUnplaned = async () => {
    console.log("formValues", formValues);
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    let params = {
      stocktake_id: id,
      vin: formValues.vin.value,
      stocktake_date: formValues.count_date.value,
      location_stocktake_id: formValues.location.value,
      remarks: formValues.remarks.value,
    };

    try {
      setOverlayLoading(true);
      const response = await dispatch(addStocktakeVehicleUnplaned(params));
      setOverlayLoading(false);

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdStocktake(id));
        await handleSearch();
        await setShow(false);
        await handleClose();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const handleConfirm = async () => {
    const params = {
      stocktake_id: id,
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleConfirmStocktake(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdStocktake(id));
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleComplate = async () => {
    const params = {
      stocktake_id: id,
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleCompleteStocktake(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdStocktake(id));
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleSaveCancel = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = {
      stocktake_id: id,
      vin: formValues.vin.value,
      von: formValues.von.value,
      remarks: formValues.remarks.value,
      vehicle_status: "5421",
    };
    console.log(params, "params");
    try {
      const response = await dispatch(editVehicle(params));
      if (response.payload.status === 200) {
        const responseConfirm = await dispatch(
          editVehicle({
            ...params,
            vehicle_status: "6320",
          })
        );

        if (responseConfirm.payload.status === 200) {
          const action = await showSuccessDialog(
            responseConfirm.payload.data.message
          );
          if (action.isConfirmed) {
            await handleClose();
            await handleSearch();
          }
        } else {
          await handleClose();
          showErrorDialog(responseConfirm.payload.data.message);
        }
      } else {
        await handleClose();

        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      await handleClose();

      console.log(error.message);
    }
  };

  const handleDelete = async (e, row) => {
    const params = [
      {
        stocktake_id: dataId.stocktake_id,
        vehicle_id: `${row.vehicle_id}`,
      },
    ];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeVehicleWorkFlowStocktake({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleModalEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleFind = async () => {
    if (scanFrom === "") {
      return showDialog("Please scan or enter code");
    }
    const params = `${scanFrom}?document_id=${id}`;
    try {
      const response = await dispatch(fetchIdVehicleFindStocktake(params));

      console.log(response, "respose");

      if (response.payload.status === 200) {
        const dataId = response.payload.data.data;

        setFormValues({
          ...formValues,
          vin: {
            value: dataId.vin,
            error: false,
            required: "Y",
          },
          von: {
            value: dataId.von,
            error: false,
            required: "N",
          },
          remarks: {
            value: dataId.remark_stocktake,
            error: false,
            required: "N",
          },
          from_location: {
            value: dataId.current_location,
            error: false,
            required: "N",
          },
          location: {
            value:
              dataId.location_stocktake_id === null ||
              dataId.location_stocktake_id ===
                "00000000-0000-0000-0000-000000000000"
                ? ""
                : dataId.location_stocktake_id,
            error: false,
            required: "Y",
          },
          location_name: {
            value: dataId.location_stocktake_name,
            error: false,
            required: "N",
          },
          count_date: {
            value: dataId.stocktake_date,
            error: false,
            required: "Y",
          },
          stocktake_planned: {
            value: dataId.stocktake_planned,
            error: false,
            required: "N",
          },
        });

        setShowScan(false);
        setCreate(true);
        setShow(true);
      } else if (
        response.payload.data.error === "16001" &&
        response.payload.data.data !== null
      ) {
        const action = await showConfirmDialog(`Vehicle with VIN as ${scanFrom} is not included in your Stock-Take Job
        planning.  Do you want to add this vehicle in your count activity?`);
        if (action.isConfirmed) {
          await setShowUnplaned(true);
          await setFormValues({
            ...formValues,
            vin: {
              value: response.payload.data.data.vin,
              error: false,
              required: "Y",
            },
            from_location: {
              value: response.payload.data.data.current_location,
              error: false,
              required: "N",
            },
            count_date: {
              value: "",
              error: false,
              required: "Y",
            },
          });
        }
      } else if (
        response.payload.data.error === "16001" &&
        response.payload.data.data === null
      ) {
        const action = await showDialog(
          `Vehicle with VIN as ${scanFrom} is not in Inventory`
        );
        setShowScan(false);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // upload file
  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [rowUpload, setRowUpload] = useState(null);
  const [showUploadView, setShowUploadView] = useState(false);

  const [showUpload, setShowUpload] = useState(false);

  const handleCloseUpload = () => {
    setShowUpload(false);
    setFile(null);
    setFileName("Upload Template File");
  };
  const handleCloseUploadView = () => {
    setShowUploadView(false);
    setRowUpload(null);
  };

  const handleUpload = async () => {
    // if (file) {
    //   return showErrorDialog("Please Input");
    // }
    const params = {
      id: id,
      file: file,
    };
    try {
      const response = await dispatch(addUploadFilePDIIN(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdStocktake(id));
        await handleCloseUpload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProses = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUpload(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdStocktake(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleProsesCancel = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUploadCancel(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdStocktake(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDownload = async () => {
    const params = {
      id: id,
      type: "STOCKTAKE_VEHICLE",
    };
    try {
      const response = await dispatch(fetchFileTemplate(params));
      if (response.payload.status === 200) {
        const response = await dispatch(fetchFileTemplateBlob(params));
        if (response.payload.status === 200) {
          const blob = new Blob([response.payload.data], {
            type: "application/xlsx",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "STOCKTAKE_WORKFLOW.xlsx";
          link.click();
        }
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  const [showLocation, setShowLocation] = useState(false);

  const [fieldsLocation, setFieldsLocation] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between mb-5 mt-5">
            <div className="p-2">
              <Button
                className="my-btn-primary-dark "
                onClick={(e) => setShowScan(true)}
                disabled={
                  dataId.process_complete === "Y" ||
                  dataId.stocktake_status_workflow === "COMPLETED"
                }
              >
                Input Details
              </Button>
            </div>
            <div className="mr-auto p-2 "></div>
            {/* <div className="mr-auto p-2 " onClick={(e) => setShowUpload(true)}>
              <Button className="my-btn-primary-dark ">Upload Details</Button>
            </div> */}
            <div className="p-2">
              <Button
                variant="outline-primary"
                onClick={handleConfirm}
                disabled={
                  dataId.process_complete === "Y" ||
                  dataId.stocktake_status_workflow === "COMPLETED"
                }
              >
                Confirm
              </Button>
            </div>
            <div className="p-2">
              <Button
                variant="primary"
                onClick={handleComplate}
                disabled={
                  dataId.process_complete === "Y" ||
                  dataId.stocktake_status_workflow === "COMPLETED"
                }
              >
                Complete
              </Button>
            </div>
          </div>
          <>
            <Tabs
              value={value}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              fullWidth
            >
              <Tab label={`Planned Vehicles`} />
              <Tab label={`Unplaned Vehicles`} />
              <Tab label={`Confirmed For Vehicles`} />
            </Tabs>
            {/*  Planned Vehicles*/}
            {value === 0 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 1 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 2 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
          </>
        </CardBody>
      </Card>

      <>
        {/* Modal Inspection */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              {row === null ? "Input" : "Update"} Count Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="VIN"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="vin"
                    value={formValues.vin.value}
                    onChange={handleChange}
                    error={formValues.vin.error}
                    helperText={
                      formValues.vin.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                    disabled
                  />
                  <RedditTextField
                    label="From Location"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="von"
                    value={formValues.from_location.value}
                    onChange={handleChange}
                    disabled
                  />
                  <RedditTextField
                    required
                    label="Count Date"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="datetime-local"
                    size="small"
                    fullWidth
                    name="count_date"
                    value={formValues.count_date.value}
                    onChange={handleChange}
                    error={formValues.count_date.error}
                    helperText={
                      formValues.count_date.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Remarks"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="remarks"
                    value={formValues.remarks.value}
                    inputProps={{ maxLength: 150 }}
                    onChange={handleChange}
                  />
                  <Row>
                    <Col xs={10} sm={3} md={10} lg={10}>
                      <RedditTextField
                        required
                        label="Location"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        value={formValues.location_name.value}
                        onChange={handleChange}
                        error={formValues.location.error}
                        helperText={
                          formValues.location.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1}>
                      <div>
                        <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => {
                              setGetData(true);
                              setShowLocation(true);
                            }}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {value !== 2 && (
              <>
                <>
                  <Button variant="primary" onClick={(e) => handleSave("save")}>
                    Save
                  </Button>
                  <Button variant="primary" onClick={handleSaveConfrim}>
                    Confirm
                  </Button>
                </>
              </>
            )}
          </Modal.Footer>
        </Modal>
        {/* Modal Unplaned */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUnplaned}
          onHide={handleClose}
        >
          <LoadingFetchData active={overlayLoading} />

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Input Count Details Unplaned
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="VIN"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="vin"
                    value={formValues.vin.value}
                    onChange={handleChange}
                    error={formValues.vin.error}
                    helperText={
                      formValues.vin.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                    disabled
                  />
                  <RedditTextField
                    label="From Location"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="von"
                    value={formValues.from_location.value}
                    onChange={handleChange}
                    disabled
                  />
                  <RedditTextField
                    required
                    label="Count Date"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="date"
                    size="small"
                    fullWidth
                    name="count_date"
                    value={formValues.count_date.value}
                    onChange={handleChange}
                    error={formValues.count_date.error}
                    helperText={
                      formValues.count_date.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Remarks"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="remarks"
                    value={formValues.remarks.value}
                    inputProps={{ maxLength: 150 }}
                    onChange={handleChange}
                  />
                  <Row>
                    <Col xs={10} sm={3} md={10} lg={10}>
                      <RedditTextField
                        required
                        label="Location"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        value={formValues.location_name.value}
                        onChange={handleChange}
                        error={formValues.location.error}
                        helperText={
                          formValues.location.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1}>
                      <div>
                        <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                          <span
                            className="svg-icon svg-icon-md svg-icon-light"
                            onClick={() => {
                              setGetData(true);
                              setShowLocation(true);
                            }}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/New/Search.svg"
                              )}
                            />
                          </span>
                        </a>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>

            <Button variant="primary" onClick={handleSaveUnplaned}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        {/* scann */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showScan}
          onHide={handleCloseScan}
          onEntered={handleModalEntered}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Scan or Enter Code
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.Control
                    ref={inputRef}
                    type="text"
                    value={scanFrom}
                    onChange={(e) => setScanFrom(e.target.value)}
                  />
                </Col>
              </Row>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseScan}>
              Close
            </Button>
            <Button variant="primary" onClick={handleFind}>
              Find
            </Button>
          </Modal.Footer>
        </Modal>

        {/* upload */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUpload}
          onHide={handleCloseUpload}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Upload
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-5">
              <h5 className="font-weight-boldest">File</h5>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.File
                    type="file"
                    id="file_fpre"
                    custom
                    label={fileName}
                    onChange={(e) => {
                      setFile(e.target.files[0]);
                      setFileName(e.target.files[0].name);
                    }}
                    accept=".xlsx, .XLSX"
                  />
                </Col>
                <Col>
                  <Button
                    variant="primary"
                    className="mr-5"
                    onClick={handleUpload}
                  >
                    Upload
                  </Button>

                  <Button variant="outline-primary" onClick={handleDownload}>
                    Download Template
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseUpload}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* upload View */}
        {rowUpload && (
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showUploadView}
            onHide={handleCloseUploadView}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Upload Vehicle Information Status
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div class="d-flex mb-5">
                <div class="p-2 mr-auto font-weight-boldest ">
                  Uploaded Vehicles Data from file "{rowUpload.file_name}"
                </div>
                <div class="p-2 font-weight-boldest">
                  Status :{rowUpload.status}{" "}
                </div>
              </div>
              {rowUpload.status === "Uploaded" && (
                <Row className="ml-2 mb-5">
                  <Button
                    variant="primary"
                    className="mr-5"
                    onClick={handleProses}
                  >
                    Process Data
                  </Button>
                  <Button variant="danger" onClick={handleProsesCancel}>
                    Cancel Process Data
                  </Button>
                </Row>
              )}

              <>
                <div
                  className=" "
                  style={{
                    maxHeight: "600px",
                    overflowY: "scroll",
                  }}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="no"
                    data={rowUpload !== null ? rowUpload.data : []}
                    columns={columnsUploadPDIIN}
                    hover
                  />
                </div>
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseUploadView}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        <ModalLocationRadio
          isOpen={showLocation}
          setShow={setShowLocation}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFieldsLocation}
          fields={fieldsLocation}
          getData={getData}
          setGetData={setGetData}
        />
      </>
    </>
  );
};
